import axios from 'axios';

const instance = axios.create({
    timeout: 5000
});

const getJobApplications = (jobId, params) => {
    let path = `/company/jobs/${jobId}.json?${params.toString()}`;

    return instance.get(path)
};

const toggleFavorite = (jobApplicationId) => {
    let path = `/favorites/${jobApplicationId}.json`;

    return instance.patch(path)
};

const hideJobApplication = (jobApplicationId) => {
  return instance.patch(`/job_applications/${jobApplicationId}`, {
    job_application: {
      hidden: true
    }
  })
};

const showJobApplication = (jobApplicationId) => {
  return instance.patch(`/job_applications/${jobApplicationId}`, {
    job_application: {
      hidden: false
    }
  })
}

const markViewedJobApplication = (jobApplicationId) => {
  const token = document.querySelector("meta[name='csrf-token']").getAttribute('content')
  instance.defaults.headers.common['X-CSRF-TOKEN'] = token
  return instance.post(`/job_applications/${jobApplicationId}/mark_viewed`, {})
}

export default {
  getJobApplications,
  toggleFavorite,
  hideJobApplication,
  showJobApplication,
  markViewedJobApplication
};
